export default "__VITE_PUBLIC_ASSET__d1151731__"